import { ENDPOINT } from '../../network/ENDPOINT';
import { putApiToServer } from '../callApi';

export async function editSubAdmin(
        authtoken,   
        payload,
        id
){
    try {
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Berear " + authtoken
        };

        let body = JSON.stringify(payload);

        let endUrl = `${ENDPOINT.edit_sub_admin}/${id}`;

        let responseData = await putApiToServer(body, header, "PUT", endUrl);

        return responseData;

    } catch (err) {
        throw err;
    }
}
